import { createContext } from 'react';

/**
  Контекст нужен для получения количества столбцов в строке, от чего зависят стили
*/
export type TPageBlocksContext = 1 | 2;

export const PageBlocksContext = createContext<TPageBlocksContext>(1);
